export default function getImageFromCdn(path: string) {
  return process.env['REACT_APP_CDN_PATH'] + path;
}
